/**
 * File: tabClassUtils.ts
 * Path: apps/admin/src/shared/utils/tabClassUtils.ts
 * Description: The underline tab style shared by the Accounting pages.
 */

import { cn } from "@idk/utils";

export const tabClass = (active: boolean) =>
  cn(
    "min-h-11 shrink-0 whitespace-nowrap border-b-2 px-stack-sm text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
    active ? "border-primary text-foreground" : "border-transparent text-muted-foreground hover:text-foreground",
  );
